import React from 'react';
import SearchBar from '@components/viewer-module/SearchBar';
import DatePicker from '@components/viewer-module/DatePicker';
import Summary from '@components/viewer-module/Summary';
import KebabDropDown from '@components/viewer-module/kebab-dropdown';
import { useViewerStore } from '@store/viewerModule/base';
import { FlexFiller } from '../styled';
import { TopPanelWrapper, HeaderWrapper, SummaryWrapper } from './styled';
import Tabs from './Tabs';

function TopPanel({ id, pageType }) {
  const [{ viewerId }] = useViewerStore();

  return (
    <React.Fragment>
      <Tabs />
      <TopPanelWrapper>
        <HeaderWrapper>
          <SearchBar />
          <FlexFiller />
          <DatePicker />
          <KebabDropDown id={id} pageType={pageType} />
        </HeaderWrapper>
        <SummaryWrapper>{viewerId ? <Summary /> : null}</SummaryWrapper>
      </TopPanelWrapper>
    </React.Fragment>
  );
}

export default TopPanel;
